import React from 'react';
import AppLayout from '../components/AppLayout';
import OverviewList from '../components/OverviewList';
import {PageMenu,DeleteListItem,GenerateSpreadsheet,AddListItem,Segment,LoadGraphic,Step,DynamicListArea,BulkEdit,DownloadTemplate} from '../components/Common';
import {EditSizeLabel,EditSizeLink,EditableBox,Select,Button,Date,Box,Time,Info,TextButton,MiniMinusButton,Area} from '../components/Input';
import {} from '../data/Options';
import u from '../utilities/Utilities';
import {Link} from 'react-router-dom';
import {Spreadsheet} from '../data/Mimetypes';
import moment from 'moment';
import store from 'store';

export default class ExitRequestList extends React.Component{

    settings={
        /**** Page Setup ****/
        title:"Exit Request",
        permission:"exit",  //Accepts combined permission module as well
        //combinedField:"price",     //Used when permission exists in a combined field
        url:"/exit-request-list",

        /**** Action Setup ****/
        addType:1,
        addURL:"/api/add-exit-request-entry",
        //templateURL:"/api/get-add-tenant-template",
        //bulkURL:"/api/add-bulk-tenants",
        deleteURL:"/api/delete-exit-request-entries",
        spreadsheetURL:"/api/generate-exit-request-spreadsheet",
        overviewURL:"/api/get-all-exit-request-entries",

        /**** List Setup ****/
        list:true,
        listLabel:"exit-request-list",
        orderByField:"requestedOn",
        orderByType:"descending",
        numRows:20,
        checkboxPermissions:{},
        overview:undefined,
        layout:()=>{return this.r['layout']},
        onPopup:(e)=>{this.r['layout'].onPopup(e)},
        onCancelPopup:(e)=>{this.r['layout'].onCancelPopup(e)}
    };

    pageComponents={
        add:{component:AddExitRequestEntry,props:{}},
        delete:{component:DeleteListItem,props:{}},
        spreadsheet:{component:GenerateSpreadsheet,props:{}},
        bulkEdit:{component:BulkEdit,props:{}},
    };

    state={
        selected:{
            tags:[],
            all:false,
            data:[],
            entryCount:0
        },
        pageMenuButtons:[],
        permissions:{},
        options:{},
    };

    componentDidMount=()=>{
        const permissions = u.getPermissions("exit");
        const bulkEditOptions = u.getBulkEdit(this.settings.listLabel);
        const bulkEditEnabled = (bulkEditOptions.length > 0 && (permissions.update));
        this.setState({
            pageMenuButtons:[
                {label:"Add",mobileLabel:"Add Entry",ref:"add",image:"/images/page-menu/add.png",title:"Add new price entry",enabled:(permissions.create)},
                {label:"Delete",mobileLabel:"Delete Entries",ref:"delete",image:"/images/page-menu/delete.png",title:"Delete selected entry",enabled:(permissions.delete)},
                {label:"Spreadsheet",mobileLabel:"Generate Spreadsheet",ref:"spreadsheet",image:"/images/page-menu/spreadsheet.png",title:"Generate spreadsheet from selection",enabled:true},
                {label:"Bulk Edit",mobileLabel:"Bulk Edit",ref:"bulkEdit",image:"/images/page-menu/edit.png",title:"Edit price details",enabled:bulkEditEnabled,padding:"3px"},
            ],
            permissions:permissions,
        });
    }

    onSelectChange=(selected)=>{
        this.setState({selected:selected});
    }

    render=()=>{
        return (
            <AppLayout ref="layout" settings={this.settings}>
                <div className="page-error-container">
                    <div className="page-error">{this.state.error}</div>
                </div>

                <PageMenu buttons={this.state.pageMenuButtons}
                          settings={this.settings}
                          components={this.pageComponents}
                          selected={this.state.selected}/>


                <OverviewList ref={(ref)=>{this.settings.overview=ref}}
                              settings={this.settings}
                              onSelectChange={this.onSelectChange}
                              registerReference={this.registerReference}
                              onMutatedChange={this.onMutatedChange}
                              location={this.props.location}>
                    {
                        (content,index,onChange,onContentChange,registerRef)=>{
                            return (
                                <ExitRequestItem key={index}
                                              index={index}
                                              content={content}
                                              onChange={onChange}
                                              onContentChange={onContentChange}
                                              registerReference={registerRef}
                                              options={this.state.options}
                                              />
                            )
                        }
                    }
                </OverviewList>

            </AppLayout>
        )
    }
}

class ExitRequestItem extends React.Component{
    state={
        step:"view",
        error:"",
        loading:false,
        loadText:"",
    };

    onApprove=()=>{
        this.setState({loading:true,loadText:"Approving...",error:""});
        u.post({
            url:"/api/update-exit-request-status",
            data:{
                exitID:this.props.content.exitID,
                status:"Approved"
            },
            success:()=>{
                this.props.onChange("Approved","status",this.props.index);
                this.setState({loading:false,error:"",step:"view"});
            },
            error:(error)=>{
                this.setState({error:error,loading:false});
            }
        });
    }

    onReject=()=>{
        this.setState({error:""});
        const rejectReason = this.refs['rejectReason'].validate();
        if(!rejectReason.valid){
            this.setState({error:rejectReason.value});
            return 0;
        }
        this.setState({loading:true,loadText:"Rejecting..."});
        u.post({
            url:"/api/update-exit-request-status",
            data:{
                exitID:this.props.content.exitID,
                status:"Rejected",
                rejectReason:rejectReason.value
            },
            success:()=>{
                this.props.onChange("Rejected","status",this.props.index);
                this.props.onChange(rejectReason.value,"rejectReason",this.props.index);
                this.setState({loading:false,error:"",step:"view"});
            },
            error:(error)=>{
                this.setState({error:error,loading:false});
            }
        });
    }

    render=()=>{
        const content = this.props.content;
        const options = this.props.options;
        const hasPassed = moment().isAfter(content.exitFrom,"seconds");

        return (
            <div>
                <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                <div className="list-segment-error">{this.state.error}</div>
                <Step active={this.state.step == "view"}>

                    <DynamicListArea content={this.props.content}
                                     onChange={this.props.onChange}
                                     index={this.props.index}
                                     listLabel={"exit-request-list"}
                                     permission="exit"/>

                    <div className="list-segment-buttons">
                        {
                            (content.status != "Rejected")
                                ?
                                <Button type="medium" onClick={()=>{this.setState({step:"reject"})}}>Reject</Button>
                                :
                                null
                        }
                        {
                            (content.status != "Approved")
                                ?
                                <Button type="medium" onClick={()=>{this.setState({step:"approve"})}}>Approve</Button>
                                :
                                null
                        }
                    </div>

                </Step>

                <Step active={this.state.step == "approve"}>
                    <div style={{padding:"30px 0",textAlign:"center"}}>
                        <h2 className="text-emphasis">Confirm Approve Request?</h2>
                        <div className="list-segment-note">Note. You may still reject the request before the exit date and the resident will be notified</div>
                        <div className='list-segment-buttons'>
                            <Button type="medium" onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                            <Button type="medium" onClick={this.onApprove}>Confirm</Button>
                        </div>
                    </div>
                </Step>

                <Step active={this.state.step == "reject"}>
                    <div style={{padding:"30px 0",textAlign:"center"}}>
                        <h2 className="text-negative">Confirm Reject Request?</h2>
                        <div className="segment-full-item" style={{fontSize:"1.1em"}}>
                            <Area ref="rejectReason" label="Reject Reason" rules={{required:false,placeholder:"(Optional) Reason for rejection, this reason will be displayed to the user"}}/>
                        </div>
                        <div className="list-segment-note">Note. You may still approve the request before the exit date and the resident will be notified</div>
                        <div className='list-segment-buttons'>
                            <Button type="medium" onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                            <Button type="medium" onClick={this.onReject}>Confirm</Button>
                        </div>
                    </div>
                </Step>
            </div>
        )
    }
}

class AddExitRequestEntry extends React.Component{

    state={
        entryData:{},
        step:"add",
    };

    show=(show)=>{
        this.refs[this.props.reference].show(show);
    }

    componentDidMount=()=>{

    }

    onCancel=()=>{
        this.setState({entryData:{}});
        this.props.onToggleForm(this.props.reference,false);
    }

    onComplete=()=>{
        this.setState({entryData:{}});
    }

    onValidate=()=>{
        this.setState({error:""});
        const keys=["tenantFIN","exitFromDate","exitFromTime","exitToDate","exitToTime","requestReason"];
        let data={};
        for(var i=0; i<keys.length; i++){
            if(this.refs[keys[i]]){
                const current = this.refs[keys[i]].validate();
                if(!current.valid){
                    this.setState({error:current.value});
                    return 0;
                }
                data[keys[i]] = current.value;
            }
        }
        data.exitFrom = data.exitFromDate + "T" + data.exitFromTime;
        data.exitTo = data.exitToDate + "T" + data.exitToTime;

        if(moment(data.exitFrom).isAfter(data.exitTo,"second")){
            this.setState({error:"To date/time cannot be before From date/time"});
            return 0;
        }

        this.refs[this.props.reference].onValidated(data);
    }

    onChange=(value,field,index,option)=>{
        let entryData = this.state.entryData;
        entryData[field] = value;
        this.setState({entryData:entryData});
    }

    render=()=>{
        const entryData = this.state.entryData;

        return(
            <AddListItem ref={this.props.reference}
                         settings={this.props.settings}
                         reference={this.props.reference}
                         onToggleForm={this.props.onToggleForm}
                         onComplete={this.onComplete}
                         >

                <div className="segment-content">
                    <div className="segment-error">{this.state.error}</div>
                    <div className="segment-content" style={{textAlign:"center"}}>
                        <div>
                            <h3>Complete the following to continue</h3>

                            <div className="segment-full-item">
                                <div className="segment-item-label">Resident FIN</div>
                                <div className="segment-item-input"><Box ref="tenantFIN" values={{value:entryData.tenantFIN}} label="Resident FIN" field="tenantFIN" rules={{required:true}} onChange={this.onChange}/></div>
                            </div>

                            <div className="segment-full-item">
                                <div className="segment-item-label">From Date</div>
                                <div className="segment-item-input">
                                    <Date ref="exitFromDate" label="Exit From" field="exitFromDate" values={{value:entryData.exitFromDate}} range={[1,2]} onChange={this.onChange}/>
                                </div>
                            </div>

                            <div className="segment-full-item">
                                <div className="segment-item-label">From Time</div>
                                <div className="segment-item-input">
                                    <Time ref="exitFromTime" values={{value:entryData.exitFromTime}} label="From Time" field="exitFromTime" rules={{skipSeconds:true}} onChange={this.onChange}/>
                                </div>
                            </div>

                            <div className="segment-full-item">
                                <div className="segment-item-label">To Date</div>
                                <div className="segment-item-input">
                                    <Date ref="exitToDate" label="Exit To" field="exitToDate" values={{value:entryData.exitToDate}} range={[1,2]} onChange={this.onChange}/>
                                </div>
                            </div>

                            <div className="segment-full-item">
                                <div className="segment-item-label">To Time</div>
                                <div className="segment-item-input">
                                    <Time ref="exitToTime" values={{value:entryData.exitToTime}} label="To Time" field="exitToTime" rules={{skipSeconds:true}} onChange={this.onChange}/>
                                </div>
                            </div>


                            <div className="segment-full-item">
                                <div className="segment-item-label">Exit Reason</div>
                                <div className="segment-item-input">
                                    <Area ref="requestReason" values={{value:entryData.requestReason}} rules={{required:true}} label="Exit Reason" field="requestReason" onChange={this.onChange}/>
                                </div>
                            </div>

                            <div className="segment-buttons">
                                {
                                    (u.isMobileDevice())
                                        ?
                                        <Button type="medium" onClick={this.onCancel}>Cancel</Button>
                                        :
                                        null
                                }
                                <Button type="medium" onClick={this.onValidate}>Create</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </AddListItem>
        )
    }
}
